import React from "react";
import { useMutation, useQueryClient } from "react-query";
import { useCookie } from "../../../hooks/useCookie";
import { useToast } from "../../../hooks/useToast";
import { general } from "../../../locales/general";
import apiService from "../../../service/apiService";
import { TranslationRow, TranslationTable } from "../Translationtableparts";

function TableBodyRowContent({
  placeTranslation,
  deletedList,
}: {
  placeTranslation: PlaceTranslation;
  deletedList: React.Dispatch<BulkDeleteActions>;
}) {
  const { toastSuccess, toastError } = useToast();
  const { token } = useCookie("vToken");
  const queryClient = useQueryClient();

  const deletePlaceTranslation = useMutation((id: string) => {
    return apiService.MakeDeleteRequest(`place-translations/${id}`, token);
  });

  const removePlaceTranslation = () => {
    deletePlaceTranslation.mutate(placeTranslation.id, {
      onError(error) {
        console.log(error);
        toastError(general.fr.message.operationFailed);
      },
      onSuccess() {
        toastSuccess(general.fr.message.partnerDeleted);
        queryClient.invalidateQueries("getAllTranslations");
      },
    });
  };

  return (
    <TranslationRow
      id={placeTranslation.id}
      deletedList={deletedList}
      withImage
      image={placeTranslation.place?.logoImage || placeTranslation.place?.image}
      sourceTitle={placeTranslation.place?.name}
      sourceSubtitle={placeTranslation.place?.city?.label}
      sourceHref={`/places/${placeTranslation.place?.id}`}
      translation={placeTranslation?.name}
      lang={placeTranslation?.lang}
      editTo={`/place-translations/update/${placeTranslation.id}`}
      onDelete={removePlaceTranslation}
      isDeleting={deletePlaceTranslation.isLoading}
    />
  );
}

interface TableProps {
  placeTranslations: PlaceTranslation[];
  placeTranslationsToBeDeleted: React.Dispatch<BulkDeleteActions>;
}

export default function PlaceTranslationsTable({
  placeTranslations,
  placeTranslationsToBeDeleted,
}: TableProps) {
  return (
    <TranslationTable sourceLabel="Établissement">
      {placeTranslations?.map((placeTranslation) => (
        <TableBodyRowContent
          placeTranslation={placeTranslation}
          key={placeTranslation?.id}
          deletedList={placeTranslationsToBeDeleted}
        />
      ))}
    </TranslationTable>
  );
}
